import { render, staticRenderFns } from "./MoreInfo.vue?vue&type=template&id=26c14e70"
import script from "./MoreInfo.vue?vue&type=script&lang=js"
export * from "./MoreInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Markdown: require('/srv/app/components/markdown/Markdown.vue').default,Button: require('/srv/app/components/button/Button.vue').default,Picture: require('/srv/app/components/picture/Picture.vue').default})
